module.exports = __webpack_public_path__ + "img/icons B_26.f3e9de26.png";